export default function SprintProgress({
  completed,
  pct,
}: {
  completed: number;
  pct: number;
}) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
      <div className="flex items-center justify-between text-xs text-slate-400 mb-2">
        <span>Avanzamento</span>
        <span>
          {completed} / 5 step completati
        </span>
      </div>
      <div className="h-2 bg-white/5 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#FF6B47] to-[#FF8A6B] rounded-full transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
